export default __webpack_public_path__ + "resources/icons/n141-2c16.png";